/** Shopify reviewers must stay on Shopify billing so app-review accounts cannot get stuck on Stripe. */
export const hasShopifyBillingNameOverride = ({
  firstName,
  lastName,
}: {
  firstName?: string | null;
  lastName?: string | null;
}): boolean => {
  const fullName = `${firstName ?? ""} ${lastName ?? ""}`.toLowerCase();
  return fullName.includes("shopify") || fullName.includes("apprev");
};

/** Reviewer email is known at signup, so it is the reliable Shopify-billing signal there. */
export const hasShopifyBillingEmailOverride = ({
  email,
}: {
  email?: string | null;
}): boolean => {
  return (email ?? "").toLowerCase().endsWith("@shopify.com");
};

export const isShopifyReviewerAccount = ({
  email,
  firstName,
  lastName,
}: {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}): boolean => {
  return (
    hasShopifyBillingEmailOverride({ email }) ||
    hasShopifyBillingNameOverride({ firstName, lastName })
  );
};
